const MSupplyChainManager = [
  {
    title: 'Dashboard',
    is_heading: false,
    is_active: false,
    link: {
      name: 'scm.dashboard'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-objects-column',
    active_icon: 'fad fa-objects-column'
  }
]

const MSCMPurchaseOrderApprovals = [
  {
    title: 'Purchase Orders',
    is_heading: true,
    is_active: false,
    link: {
      name: 'scm.purchase-orders'
    },
    class_name: 'mt-3 font-weight-bolder'
  },
  {
    title: 'Approvals',
    is_heading: false,
    is_active: false,
    link: {
      name: 'scm.purchase-orders.approvals'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-cart-circle-check',
    active_icon: 'fad fa-cart-circle-check'
  }
]

const MSCMInterWarehouseApprovals = [
  {
    title: 'Inter Warehouses',
    is_heading: true,
    is_active: false,
    link: {
      name: 'scm.inter-warehouses'
    },
    class_name: 'mt-3 font-weight-bolder'
  },
  {
    title: 'Approvals',
    is_heading: false,
    is_active: false,
    link: {
      name: 'scm.inter-warehouses.approvals'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-cart-circle-arrow-up',
    active_icon: 'fad fa-cart-circle-arrow-up'
  }
]

const MSCMAtwApprovals = [
  {
    title: 'ATWs',
    is_heading: true,
    is_active: false,
    link: {
      name: 'scm.atws'
    },
    class_name: 'mt-3 font-weight-bolder'
  },
  {
    title: 'Approvals',
    is_heading: false,
    is_active: false,
    link: {
      name: 'scm.atws.approvals'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-cart-circle-arrow-up',
    active_icon: 'fad fa-cart-circle-arrow-up'
  }
]

export default MSupplyChainManager.concat(
  MSCMPurchaseOrderApprovals,
  MSCMInterWarehouseApprovals,
  MSCMAtwApprovals
)
